import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../../../environments/environment";
import {MatPaginator} from '@angular/material/paginator';
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {CentreService} from "../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {Centre, CentreOption} from "../../../../interfaces/Centres";
import {LogService} from "../../../../services/log.service";
import {dE} from "@fullcalendar/core/internal-common";
import {UserData} from "../../../../auth.service";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import * as XLSX from "xlsx";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-counseling-impact-report-table',
  templateUrl: './counseling-impact-report-table.component.html',
  styleUrls: ['./counseling-impact-report-table.component.scss']
})
export class CounselingImpactReportTableComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  centres$: Observable<CentreOption[]>;
  selectedCentre: any | null = null;
  SelectedCenters: any | null;
  startDate: Date | undefined
  endDate: Date | undefined
  externalUser: boolean = false;
  selectedSubmitType: any
  userData: UserData
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  counsellingreports = this.permissions.filter((x) => x.functionName == 'Counseling Report')[0]

  filteredDataSource = new MatTableDataSource<any>(); // Filtered data
  displayedColumns = ['sr', 'centreName', 'individualSessions', 'groupSessions', 'assessmentSessions', 'from', 'to', 'submitType', 'createdAt', 'actions']
  dataSource: MatTableDataSource<any>; // Data source for the table
  private originalData: any[] = [];
  constructor(private mFirestore: AngularFirestore,
              private mSnackbar: MatSnackBar,
              private mLogService: LogService,
              private readonly mCentreService: CentreService,
              private readonly financialYearService: FinancialYearService,
              private mRouter: Router) {
    this.dataSource = new MatTableDataSource<any>()
    this.centres$ = this.mCentreService.getAllCentresOptions().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    );
    this.userData = JSON.parse(localStorage.getItem('userData')!) as UserData
    this.externalUser = this.userData.department === 'External User'
  }

  ngOnInit(): void {
    this.centres$ = this.mCentreService.getAllCentresOptions().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    );
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.fetchData();
  }

  fetchData() {
    this.mFirestore.collection(this.env.counsellingImpactReport, ref => ref.orderBy('createdAt', 'desc')).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
      this.originalData = data;
      this.dataSource.data = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }


  clearAll() {
    this.SelectedCenters = null;
    this.selectedCentre = null;
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedSubmitType = null;
    this.dataSource.data = [...this.originalData];
    this.dataSource.paginator = this.paginator;
  }

  filterData(): void {
    let filteredData = [...this.originalData];

    if (this.selectedCentre && this.selectedCentre !== 'All') {
      filteredData = filteredData.filter(report => report.centreCode === this.selectedCentre);
    }

    if (this.selectedSubmitType) {
      filteredData = filteredData.filter(report =>
        report.submitType && report.submitType.toLowerCase() === this.selectedSubmitType.toLowerCase()
      );
    }

    if (this.startDate && this.endDate) {
      const start = this.startDate.getTime();
      const end = this.endDate.getTime();
      filteredData = filteredData.filter(report => {
        const reportFrom = report.from.seconds * 1000;
        const reportTo = report.to.seconds * 1000;
        return reportFrom >= start && reportTo <= end;
      });
    }

    this.dataSource.data = filteredData;
    this.dataSource.paginator = this.paginator;
  }

  onCenterSelectionChange(event: any): void {
    this.selectedCentre = event.value.centreCode;
  }

  // search() {
  //   if (this.selectedCentre && this.selectedCentre.centreCode != 'All') {
  //     this.mFirestore.collection('CounselingImpactReport', ref =>
  //       ref.where('centreCode', '==', this.selectedCentre?.centreCode).orderBy('createdAt', 'desc')).valueChanges({idField: 'id'}).subscribe((data: any) => {
  //       this.dataSource.data = data; // Assign fetched data to dataSource
  //       this.dataSource.paginator = this.paginator
  //       this.dataSource.sort = this.sort
  //     });
  //   } else {
  //     this.mFirestore.collection('CounselingImpactReport', ref => ref.orderBy('createdAt', 'desc')).valueChanges({idField: 'id'}).subscribe((data: any) => {
  //       this.dataSource.data = data; // Assign fetched data to dataSource
  //       this.dataSource.paginator = this.paginator
  //       this.dataSource.sort = this.sort
  //     });
  //   }
  // }

  addReport() {
    this.mRouter.navigateByUrl('home/reports/impact-report-counseling')
  }

  ViewReport(id: any) {
    this.mRouter.navigate(['home/reports/impact-report-counseling', id])
  }

  ViewReportImpact(id: any) {
    this.mRouter.navigate(['home/reports/view-impact-report-counseling', id])

    let activity = {
      date: new Date().getTime(),
      section: 'Counselling Reports',
      action: 'View',
      description: `Counseling view Counseling Impact by user`,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  @needConfirmation()
  deleteReport(id: any) {
    this.mFirestore.collection(this.env.counsellingImpactReport).doc(id).delete().then(() => {
      this.mSnackbar.open('Deleted', '', {
        panelClass: 'success-snackbar',
        duration: 3000
      })
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  downloadExcel() {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      this.mSnackbar.open('No data available to download', '', {
        duration: 2000
      });
      return;
    }

    const exportData = this.dataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Centre Name': item.centreName || '',
      'Individual Sessions': item.sessionCounts?.individualSessions ?? 0,
      'Group Sessions': item.sessionCounts?.groupSessions ?? 0,
      'Assessment Sessions': item.sessionCounts?.assessmentSessions ?? 0,
      'Total Sessions': item.sessionCounts?.totalSessions ?? 0,
      'From Date': item.from?.seconds
        ? new Date(item.from.seconds * 1000).toLocaleDateString()
        : '',
      'To Date': item.to?.seconds
        ? new Date(item.to.seconds * 1000).toLocaleDateString()
        : '',
      'Submit Type': item.submitType ? item.submitType.toUpperCase() : '',
      'Created Date': item.createdAt?.seconds
        ? new Date(item.createdAt.seconds * 1000).toLocaleDateString()
        : ''
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Counseling Impact Report');

    XLSX.writeFile(workbook, 'Counseling_Impact_Report.xlsx');

    // Activity log (matches your existing pattern)
    const activity = {
      date: new Date().getTime(),
      section: 'Counselling Reports',
      action: 'Download',
      description: 'Counseling Impact Report downloaded as Excel',
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.mSnackbar.open('Excel downloaded successfully', '', {
      duration: 2000
    });
  }


  protected readonly PermissionType = PermissionType;
}
